import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';
import { useError } from '../context/ErrorContext';
import { useNavigate, useSearchParams } from 'react-router-dom';

const ErrorDialog: React.FC = () => {
  const { error, status, clearError } = useError();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const handleTakeMeHome = () => {
    const orgId = searchParams.get('orgId');
    const search = orgId ? `?orgId=${orgId}` : '';
    clearError();
    navigate({ pathname: '/', search });
  };

  const handleClose = () => {
    if (status !== 403) {
      clearError();
    }
  };

  const handleReload = () => {
    clearError();
    window.location.reload();
  };

  const isInvalidToken = status === 401 || (status === 403 && error?.includes('Invalid token'));

  return (
    <Dialog open={!!error} onClose={handleClose}>
      <DialogTitle>{isInvalidToken ? 'Session Expired' : 'Error'}</DialogTitle>
      <DialogContent>
        <DialogContentText component="pre">
          {isInvalidToken ? 'Your session has expired. Please log in again.' : error}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {isInvalidToken ? (
          <Button onClick={handleReload} color="primary" autoFocus>
            Reload
          </Button>
        ) : status === 403 ? (
          <Button onClick={handleTakeMeHome} color="primary" autoFocus>
            Take me Home
          </Button>
        ) : (
          <Button onClick={handleClose} color="primary" autoFocus>
            Close
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ErrorDialog;
